import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { CreatorStorySection } from './components/CreatorStorySection';
import { LeadSection } from './components/LeadSection';
import { AgitationSection } from './components/AgitationSection';
import { SolutionsFailSection } from './components/SolutionsFailSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatIncludesSection } from './components/WhatIncludesSection';
import { ProductIntro } from './components/ProductIntro';
import { IncludesSection } from './components/IncludesSection';
import { OriginStory } from './components/OriginStory';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ForWhomSection } from './components/ForWhomSection';
import { RiskReversal } from './components/RiskReversal';
import { UrgencySection } from './components/UrgencySection';
import { PricingSection } from './components/PricingSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-charcoal text-offwhite font-sans selection:bg-sand/30 selection:text-sand" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <CreatorStorySection data-id="element-4" />
        <LeadSection data-id="element-5" />
        <AgitationSection data-id="element-6" />
        <SolutionsFailSection data-id="element-7" />
        <MechanismSection data-id="element-8" />
        <WhatIncludesSection data-id="element-9" />
        <ProductIntro data-id="element-10" />
        <IncludesSection data-id="element-11" />
        <OriginStory data-id="element-12" />
        <TestimonialsSection data-id="element-13" />
        <ForWhomSection data-id="element-14" />
        <RiskReversal data-id="element-15" />
        <UrgencySection data-id="element-16" />
        <PricingSection data-id="element-17" />
        <FinalCTA data-id="element-18" />
      </main>

      <Footer data-id="element-19" />
    </div>;
}